(function (angular) {

    'use strict';

    angular.module('app.purchase')
        .controller('app.purchase.PurchaseFlowController', ['$state',
            function ($state) {
                var vm = this;
                vm.$state = $state;
                vm.tabStates = [
                    'app.purchase.plans', 'app.purchase.applicants', 'app.purchase.payment', 'app.purchase.activation'
                ];

                //  functions
                vm.changeTabs = changeTabs;
                vm.isDisabled = isDisabled;

                function changeTabs(newTab) {
                    if (!isDisabled(newTab)) {
                        $state.go(newTab);
                    }
                } 

                function isDisabled(tab) {
                    return vm.tabStates.indexOf(tab) > vm.tabStates.indexOf($state.current.name);
                }
            }]);
})(angular);

